// extracted by mini-css-extract-plugin
module.exports = {"countDownTimer":"CountdownTimer-module--countDownTimer--27xnK","countDownTimerInner":"CountdownTimer-module--countDownTimerInner--_wz0H"};